module.exports = __webpack_public_path__ + "static/media/O8.fa112c8a.png";